import { Component } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-aggiungi-newsletter-backoffice',
  templateUrl: './aggiungi-newsletter-backoffice.component.html',
  styleUrl: './aggiungi-newsletter-backoffice.component.css'
})
export class AggiungiNewsletterBackofficeComponent {
  
  constructor(private apiService: ApiService, private router: Router) { }

  formNewsletter!: FormGroup;

  ngOnInit(): void {

    this.formNewsletter = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email])
    })

  }

  onSubmit() {

    let newsletter = {
      email: this.formNewsletter.get('email')?.value
    }

    this.apiService.addNewsletter(newsletter).subscribe({
      next: (data) => this.apiService.setNewsletters(),
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.router.navigate(['/backoffice/newsletter'])
      }
    })
  }
}

